import React from 'react'
import { Box, Callout } from '@node-space/ui-components'
import { ConfirmPayeeMatchStatuses, ConfirmPayeeResponse } from 'types/payoutsV2'
import { ConfirmationOfPayeeCalloutType } from '../types'
import { ConfirmationOfPayeeCalloutCta } from './ConfirmationOfPayeeCalloutCta'

interface ConfirmationOfPayeeCalloutProps {
  type: ConfirmationOfPayeeCalloutType
  confirmationOfPayeeCallout: string
  confirmPayeeData: ConfirmPayeeResponse
  editBankAccount?: boolean
  handleEditBankAccount?: () => void
}

export const ConfirmationOfPayeeCallout = ({
  type,
  confirmationOfPayeeCallout,
  confirmPayeeData,
  editBankAccount,
  handleEditBankAccount,
}: ConfirmationOfPayeeCalloutProps) => {
  return (
    <>
      {confirmationOfPayeeCallout && (
        <Box paddingT={16}>
          <Callout
            variant={
              confirmPayeeData?.matchStatus === ConfirmPayeeMatchStatuses.MATCH ? 'info' : 'warning'
            }
          >
            <div className="flex items-center gap-1 flex-wrap">
              <span>{confirmationOfPayeeCallout}</span>
              {editBankAccount && (
                <ConfirmationOfPayeeCalloutCta
                  type={type}
                  handleEditBankAccount={handleEditBankAccount}
                />
              )}
            </div>
          </Callout>
        </Box>
      )}
    </>
  )
}
